import { useTranslationsContext } from '@state/checkout-contexts';
import { UiBankCard } from '@ui/molecules-bank-card';

import { useScaPaymentDetails } from '../../hooks/useScaPaymentDetails/useScaPaymentDetails';
import { TEST_IDS } from '../../models/globals/testIds.constants';
import { useInstitutionDetailsContext } from '../../providers/InstitutionDetailsContextProvider/InstitutionDetailsContextProvider';
import { TRANSLATION_KEYS } from '../../utils/TranslationKeys';

import type { BankCardProps } from './BankCard.types';

export function BankCard({ additionalInfo }: BankCardProps) {
  const { t } = useTranslationsContext();
  const { bankName, logoUrl, isInstitutionDataLoading } =
    useInstitutionDetailsContext();
  const { paymentDetails } = useScaPaymentDetails();

  const iban = paymentDetails?.payer?.accountIdentifiers?.iban;

  return (
    <UiBankCard.Wrapper
      sectionAriaLabel={t(TRANSLATION_KEYS.SELECTED_BANK_DETAILS)}
      isLoading={isInstitutionDataLoading}
      iconUrl={logoUrl}
      disabled
      additionalInfo={additionalInfo}
    >
      <UiBankCard.Header>{t(TRANSLATION_KEYS.PAYING_WITH)}</UiBankCard.Header>
      <UiBankCard.BankName
        dataTestId={TEST_IDS.BANK_NAME_LABEL}
        isLoading={isInstitutionDataLoading}
        loadingAriaLabel={t(TRANSLATION_KEYS.LOADING_BANK_INFORMATION)}
      >
        {bankName}
      </UiBankCard.BankName>
      {iban && (
        <UiBankCard.MaskedIban
          iban={iban}
          ariaLabel={({ prefix, suffix }) =>
            t(TRANSLATION_KEYS.MASKED_IBAN_ACCESSIBLE, { prefix, suffix })
          }
        />
      )}
    </UiBankCard.Wrapper>
  );
}
